export default function AlfaLeiloesHome() {

  function closeAllDropdowns() {
    const dropdowns = document.querySelectorAll(".custom-dropdown-content");
    dropdowns?.forEach((dropdown) => {
      dropdown.style.display = "none";
    });
  }

  function toggleDropdown(dropdownId) {
    let dropdown = document.getElementById(dropdownId);
    let display = dropdown.style.display;

    if (display === "block") {
      dropdown && (dropdown.style.display = "none");
    } else {
      closeAllDropdowns();
      dropdown && (dropdown.style.display = "block");
    }
  }

  function addToggleEvent(buttonId, dropdownId) {
    let button = document.getElementById(buttonId);
    button?.addEventListener("click", function () {
      toggleDropdown(dropdownId);
    });
  }

  addToggleEvent("categorias-button", "categorias-dropdown");
  addToggleEvent("estado-button", "estado-dropdown");
  addToggleEvent("cidade-button", "cidade-dropdown");
  addToggleEvent("bairro-button", "bairro-dropdown");
  addToggleEvent("preco-button", "preco-dropdown");
}
